import React from 'react'
import get from 'lodash/get'
import styled from 'styled-components'
import HelpModal from '@pcln/help-modal'
import { Box, Button } from 'pcln-design-system'
import { usePartner } from '@pcln/partner-config'

const StyledBox = styled(Box)`
  text-align: center;
  font-size: 14px;
  font-weight: 700;
`

const StyledHelpModal = styled(HelpModal)`
  padding: 0;

  ol,
  ul {
    list-style: none;
    padding: 0;
  }

  p,
  p ~ ul,
  p ~ ol {
    font-size: 14px;
    line-height: 21px;
    font-weight: normal;

    strong {
      font-weight: bold;
    }
  }
`

type HelpModal = {
  id: number
  overlayId: string
  type: string
  partnerMetaData: {
    brandName: string
    websiteUrl: string
    policyUrl: string
    addendum: string
  }
}

function TermsAndConditionsModal() {
  const [isOpen, setIsOpen] = React.useState(false)
  const partner = usePartner()
  const { globalPartnerCode, plfCode, config } = partner || {}

  const helpModal: HelpModal = {
    id: 123455, // TODO: PKG-6927 update id once available from CARES
    overlayId: 'termsAndConditions',
    type: 'tandc',
    partnerMetaData: {
      brandName: get(config, 'head.meta.brandName', ''),
      websiteUrl: get(config, 'head.meta.websiteUrl', ''),
      policyUrl: get(config, 'urls.termsAndConditions', ''),
      addendum: get(config, 'addendums.termsAndConditions', '')
    }
  }

  return plfCode === 'UNTD' ? (
    <StyledBox color="background.light" py={2}>
      <Button variation="link" onClick={() => setIsOpen(true)}>
        Terms and conditions
      </Button>
      <StyledHelpModal
        key={`help-modal-${helpModal.id}`}
        isOpen={isOpen}
        id={helpModal.id.toString()}
        type={helpModal.type}
        globalPartnerCode={globalPartnerCode}
        language="en-us"
        onClose={() => setIsOpen(false)}
        partnerMetaData={helpModal.partnerMetaData || {}}
      />
    </StyledBox>
  ) : null
}

export default TermsAndConditionsModal
